// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function blacklistPage(page) {
  if (typeof page === "object") {
    if (page.TAG === "ArcadeGame") {
      return true;
    } else {
      return false;
    }
  }
  switch (page) {
    case "AvatarShop" :
    case "Arcade" :
        return true;
    default:
      return false;
  }
}

function blacklistItem(item) {
  if (typeof item !== "object") {
    return true;
  } else {
    return blacklistPage(item._0);
  }
}

function isPageBlacklisted(locked, page) {
  if (locked) {
    return blacklistPage(page);
  } else {
    return false;
  }
}

function isItemBlacklisted(locked, item) {
  if (locked) {
    return blacklistItem(item);
  } else {
    return false;
  }
}

function redirectIfNotLocked(locked, onLockClicked, redirectOk, page) {
  if (locked && isPageBlacklisted(locked, page)) {
    return onLockClicked();
  } else {
    return redirectOk(page);
  }
}

function use(locked, page, redirectToMissions, redirect) {
  React.useEffect((function () {
          if (isPageBlacklisted(locked, page)) {
            redirectToMissions();
          }
          
        }), [
        page,
        locked
      ]);
  var match = React.useState(function () {
        return false;
      });
  var setLockedModal = match[1];
  var onToggleLocked = function () {
    setLockedModal(function (l) {
          return !l;
        });
  };
  return [
          (function (__x) {
              redirectIfNotLocked(locked, onToggleLocked, redirect, __x);
            }),
          onToggleLocked,
          match[0]
        ];
}

export {
  blacklistPage ,
  blacklistItem ,
  isPageBlacklisted ,
  isItemBlacklisted ,
  redirectIfNotLocked ,
  use ,
}
/* react Not a pure module */
